import * as React from 'react';
// import { Redirect } from 'react-router';
import LoginServices from '../../../services/LoginServices';
import { AxiosError } from 'axios';
import { UserRole } from '../../../types/UserRole';
import { Redirect } from 'react-router';
import { Actions } from '../LoginPage';
import { LoaderButton } from '../../genericComponents/Button/LoaderButton';

interface Props {
    actionHandler: (action: Actions) => void;
}

interface State {
    loginInfo: string;
    passwordInfo: string;
    redirect: boolean;
    loading: boolean;
}

/**
 * ce composant permet l'affiche du formulaire de login
 */
export class FormLogin extends React.Component {

    props: Props;
    state: State;

    constructor(props: Props) {
        super(props);
        this.state = {
            loginInfo: '',
            passwordInfo: '',
            redirect: false,
            loading: false,
        };
    }

    handleChangeLogin = (event: React.ChangeEvent<HTMLInputElement>) => {
        this.setState({ loginInfo: event.target.value });
    }

    handleChangePassword = (event: React.ChangeEvent<HTMLInputElement>) => {
        this.setState({ passwordInfo: event.target.value });
    }

    handleSubmit = () => {
        /*var newState: State = {loginInfo: 'Admin', passwordInfo: '12345'};
        this.setState(newState);
        alert('username: ' + newState.loginInfo + '   password: ' + newState.passwordInfo) ;*/
        if (this.state.loginInfo === '') {
            alert('enter a username');
        } else if (this.state.passwordInfo === '') {
            alert('enter a password');
        } else {
            this.setState({ loading: true });
            const loginServices = LoginServices.getInstance();
            return (loginServices.login(this.state.loginInfo, this.state.passwordInfo)
                .then(response => {
                    if (loginServices.getUserToken() !== '') {
                        this.setState({ redirect: true });
                    }
                }).catch(
                    (error: AxiosError) => {
                        this.setState({ loading: false });
                        alert('Bad password or username');
                    }
                ));
        }
        return Promise.reject('');
    }

    render() {
        const userRole = LoginServices.getInstance().getType();

        if (
            this.state.redirect &&
            (
                userRole === UserRole.ADMIN.toString() ||
                userRole === UserRole.MEMBER.toString() ||
                userRole === UserRole.USER.toString() ||
                userRole === UserRole.SEMI_PRO.toString()
            )
        ) {
            return <Redirect to={'/home'} />;
        } else if (
            this.state.redirect &&
            (
                userRole === UserRole.SUPER_ADMIN.toString()
            )
        ) {
            return <Redirect to={'/admin'} />;
        } else {
            return (
                <div className="col-12" >
                    <div className="form-group">
                        <input
                            className="form-control"
                            placeholder="Nom d'utilisateur"
                            value={this.state.loginInfo}
                            onChange={this.handleChangeLogin}
                            onKeyPress={
                                (event: React.KeyboardEvent<HTMLInputElement>) => {
                                    if (event.key === 'Enter') {
                                        this.handleSubmit();
                                    }
                                }
                            }
                            name="Username"
                            type="text"
                        />
                    </div>
                    <div className="form-group">
                        <input
                            className="form-control"
                            placeholder="Mot de passe"
                            value={this.state.passwordInfo}
                            onChange={this.handleChangePassword}
                            onKeyPress={
                                (event: React.KeyboardEvent<HTMLInputElement>) => {
                                    if (event.key === 'Enter') {
                                        this.handleSubmit();
                                    }
                                }
                            }
                            name="password"
                            type="password"
                        />
                        <small id="emailHelp" className="form-text text-muted">
                            <u
                                onClick={() => {
                                    this.props.actionHandler(Actions.RESET);
                                }}
                            >
                                Mot de passe oublié?
                            </u>
                        </small>
                    </div>
                    <hr />
                    <LoaderButton
                        className="btn btn-lg col-12"
                        onClick={() => {
                            return this.handleSubmit();
                        }}
                        load={this.state.loading}
                    >
                        Se connecter
                    </LoaderButton>
                </div>
            );
        }
    }
}


// WEBPACK FOOTER //
// ./src/components/LoginPage/internalComponents/FormLogin.tsx